export default __webpack_public_path__ + "static/case06-82f288b4122f26631eefea9032a83182.webp";